import Link from 'next/link';
import { useTranslation } from '../../lib/i18n';

const Value = ({
  value,
  currentValue,
  parameter,
  className = '',
  currentColor = '',
}) => (
  <Link
    href={`/wein?filter=${parameter}--${value}f-t${value}`}
    className={`${className} ${
      value == currentValue ? currentColor || 'bg-black' : 'bg-gray-200'
    } h-2 w-1/5 transition duration-200 hover:cursor-pointer hover:bg-green`}
  ></Link>
);

const HistogramValue = ({
  value,
  startLabel,
  endLabel,
  parameter,
  className = '',
  currentColor = '',
}) => (
  <div className={className}>
    <div
      className='flex'
      role='slider'
      aria-valuemin={1}
      aria-valuenow={value}
      aria-valuemax={5}
      aria-labelledby={`${startLabel}Label`}
    >
      <Value
        currentValue={value}
        value='1'
        className={`mr-2px`}
        parameter={parameter}
        currentColor={currentColor}
      />
      <Value
        currentValue={value}
        value='2'
        className={`mr-2px`}
        parameter={parameter}
        currentColor={currentColor}
      />
      <Value
        currentValue={value}
        value='3'
        className={`mr-2px`}
        parameter={parameter}
        currentColor={currentColor}
      />
      <Value
        currentValue={value}
        value='4'
        className={`mr-2px`}
        parameter={parameter}
        currentColor={currentColor}
      />
      <Value
        currentValue={value}
        parameter={parameter}
        value='5'
        currentColor={currentColor}
      />
    </div>
    <div
      className={`flex justify-between pt-1 font-bold ${currentColor && 'mt-[-8px]'}`}
      id={`${startLabel}Label`}
    >
      <label>{startLabel}</label> <label>{endLabel}</label>
    </div>
  </div>
);

export const Histogram = ({
  wine: { attributes },
  className = '',
  currentColor = '',
}) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <HistogramValue
        value={attributes.alkohol.value}
        parameter='alkohol'
        startLabel={t('light')}
        endLabel={t('heavy')}
        className='my-6'
        currentColor={currentColor}
      />
      <HistogramValue
        value={attributes.saeure.value}
        parameter='saeure'
        startLabel={t('mild')}
        endLabel={t('acidic')}
        className='my-6'
        currentColor={currentColor}
      />
      {attributes.farbe.valueSlug == 'rot' && (
        <HistogramValue
          value={attributes.tanine.value}
          parameter='tanine'
          startLabel={t('velvety')}
          endLabel={t('strong')}
          className='my-6'
          currentColor={currentColor}
        />
      )}
    </div>
  );
};
